import { Button, Checkbox, Dropdown } from "antd";
import { useTranslation } from "react-i18next";
import { COLUMN_KEYS, type ColumnKey, LOCKED_COLUMNS } from "../utils/columnPrefs";
import type { Tarjima } from "../utils/i18n";

/**
 * Menyudagi yorliqlar — `EmployeesPage` jadval sarlavhalari bilan BIR XIL
 * `employees.json` kalitlaridan (`list.columns.*`).
 */
function columnLabel(t: Tarjima, key: ColumnKey): string {
	const kalitlar: Record<ColumnKey, string> = {
		fullName: "list.columns.fullName",
		phone: "list.columns.phone",
		positionId: "list.columns.position",
		departmentId: "list.columns.department",
		zone: "list.columns.zone",
		attendance30: "list.columns.attendance30",
		avgLate: "list.columns.avgLate",
		hrStatus: "list.columns.hrStatus",
		risk: "list.columns.risk",
	};

	return t(kalitlar[key]);
}

/**
 * «Ustunlar» menyusi — qaysi ustunlar ko'rinishini tanlaydi.
 *
 * ⚠️ Majburiy ustunlar (`LOCKED_COLUMNS`) `disabled` — ularsiz jadval
 * kimning qatori ekanini ham, uning holatini ham aytmasdi.
 *
 * ⚠️ Har `Checkbox` va menyu konteyneri `stopPropagation()` oladi:
 * `Dropdown` ning ichki hodisasi sarlavha satridagi tugmalar bilan bir xil
 * naqshda to'xtatiladi, aks holda menyu har tanlovda yopilardi.
 */
export function EmployeeColumnsMenu({
	visible,
	onChange,
}: {
	visible: Set<ColumnKey>;
	onChange: (next: Set<ColumnKey>) => void;
}) {
	const { t } = useTranslation("employees");

	const toggle = (key: ColumnKey) => {
		const next = new Set(visible);

		if (next.has(key)) {
			next.delete(key);
		} else {
			next.add(key);
		}

		for (const locked of LOCKED_COLUMNS) {
			next.add(locked);
		}

		onChange(next);
	};

	return (
		<Dropdown
			trigger={["click"]}
			menu={{
				items: COLUMN_KEYS.map((key) => ({
					key,
					label: (
						<Checkbox
							checked={visible.has(key)}
							disabled={LOCKED_COLUMNS.includes(key)}
							onClick={(event) => {
								event.stopPropagation();
							}}
							onChange={() => {
								toggle(key);
							}}
						>
							{columnLabel(t, key)}
						</Checkbox>
					),
				})),
			}}
		>
			<Button
				onClick={(event) => {
					// ⚠️ Sarlavha satridagi tugma jadval qatori ichida emas, lekin
					// naqsh bir xil saqlanadi — tugma keyinchalik ko'chirilsa ham
					// qatorning `onClick` i ishlab ketmaydi.
					event.stopPropagation();
				}}
			>
				{t("columnsMenu.button")}
			</Button>
		</Dropdown>
	);
}
